import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ListUsers from './pages/ListUsers';
import Valet from './pages/Valet';
import Announcements from './pages/Announcements';
import EventCalendar from './pages/EventCalendar';
import Reservations from './pages/Reservations';
import Specials from './pages/Specials';
import Menu from './pages/Menu';
import PushNotifications from './pages/PushNotifications';
import Scheduling from './pages/Scheduling';
import Rewards from './pages/Rewards';
import MockDataDemo from './pages/MockDataDemo';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <ListUsers />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/valet"
            element={
              <ProtectedRoute>
                <Layout>
                  <Valet />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/announcements"
            element={
              <ProtectedRoute>
                <Layout>
                  <Announcements />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/events"
            element={
              <ProtectedRoute>
                <Layout>
                  <EventCalendar />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reservations"
            element={
              <ProtectedRoute>
                <Layout>
                  <Reservations />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/specials"
            element={
              <ProtectedRoute>
                <Layout>
                  <Specials />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/menu"
            element={
              <ProtectedRoute>
                <Layout>
                  <Menu />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/push-notifications"
            element={
              <ProtectedRoute>
                <Layout>
                  <PushNotifications />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scheduling"
            element={
              <ProtectedRoute>
                <Layout>
                  <Scheduling />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/rewards"
            element={
              <ProtectedRoute>
                <Layout>
                  <Rewards />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mock-data-demo"
            element={
              <ProtectedRoute>
                <Layout>
                  <MockDataDemo />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/users" replace />} />
          <Route path="*" element={<Navigate to="/users" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
